import React, { useEffect, useState } from "react";
import axios from "axios";

type Impact = {
  _id: string;
  title: string;
  percentage: string;
  description: string;
};

type ApiContent = {
  _id: string;
  heading: string;
  description: string;
};

const Fellowship: React.FC = React.memo(() => {
  const [impactList, setImpactList] = useState<Impact[]>([]);
  const [apiContent, setApiContent] = useState<ApiContent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [impactRes, contentRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/shaping-change-makers`),
          axios.get(
            `${process.env.REACT_APP_LOCAL_URL}/api/content/68efb02504bdd5cc2b26138d`
          ),
        ]);

        if (impactRes.data.status === "success") {
          setImpactList(impactRes.data.data || []);
        }

        if (contentRes.data.status === "success") {
          setApiContent(contentRes.data.data || null);
        }
      } catch (error) {
        console.error("Error fetching fellowship data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  return (
    <section className="gsap-fade-in w-container bg-[#FFFFFF]">
      <header className="md:flex items-end justify-between border-b border-[#84848480] border-opacity-50">
        <h1 className="pb-3 font-lato-bold text-[#07393C]">
          {apiContent?.heading}
        </h1>
      </header>

      <h6
        className="font-lato-regular text-black w-full xl:my-8 my-4"
        dangerouslySetInnerHTML={{ __html: apiContent?.description ?? "" }}
      />

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 xl:pr-10">
        {impactList.map((elem) => {
          const isCatalyst = elem.title === "Our catalysts for change";

          return (
            <article
              key={elem._id}
              className={`${
                isCatalyst ? "bg-[#22574D]" : "bg-[#D7DF23]"
              } h-52 sm:h-[277px] py-5 flex flex-col justify-between`}
            >
              <header
                className={`w-container-sm sm:w-container flex items-center gap-x-2 font-lato-bold ${
                  isCatalyst ? "text-[#D7DF23]" : "text-[#07393C]"
                }`}
              >
                <h4>{elem.title}</h4>
              </header>

              <div
                className={`w-container-sm sm:w-container font-lato-bold ${
                  isCatalyst ? "text-white" : "text-black"
                }`}
              >
                {elem.percentage && (
                  <h3 className="text-36">{elem.percentage}</h3>
                )}
                <p className="2xl:w-full xl:w-[90%]">{elem.description}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
});

export default Fellowship;
